package common.dto

import ext.asQuat
import three.js.Quaternion
import three.js.Vector3

/**
 * Simple directions in 3D space.
 *
 * @param normal The normalized normal vector of the direction. Direction that the object is facing with its z-axis.
 * @param quaternion The quaternion that needs to be applied to the object to face the direction.
 */
enum class Direction(
    val normal: Vec3d, val quaternion: Quat
) {
    /**
     * Toward positive y.
     */
    UP(Vec3d(y = 1.0), Quaternion().setFromUnitVectors(Vector3(0, 0, 1), Vector3(0, 1, 0)).asQuat()),

    /**
     * Toward negative y.
     */
    DOWN(Vec3d(y = -1.0), Quaternion().setFromUnitVectors(Vector3(0, 0, 1), Vector3(0, -1, 0)).asQuat()),

    /**
     * Toward negative x.
     */
    LEFT(Vec3d(x = -1.0), Quaternion().setFromUnitVectors(Vector3(0, 0, 1), Vector3(-1, 0, 0)).asQuat()),

    /**
     * Toward positive x.
     */
    RIGHT(Vec3d(x = 1.0), Quaternion().setFromUnitVectors(Vector3(0, 0, 1), Vector3(1, 0, 0)).asQuat()),

    /**
     * Toward positive z, towards the viewer.
     */
    FORWARD(Vec3d(z = 1.0), Quat()),

    /**
     * Toward negative z, away from the viewer.
     */
    BACKWARD(Vec3d(z = -1.0), Quaternion().setFromUnitVectors(Vector3(0, 0, 1), Vector3(0, 0, -1)).asQuat());

    companion object {
        // todo can we improve this? do we need to?
        fun from(normal: Vec3d) = when {
            normal.x > 0.99 -> RIGHT
            normal.x < -0.99 -> LEFT
            normal.y > 0.99 -> UP
            normal.y < -0.99 -> DOWN
            normal.z > 0.99 -> FORWARD
            normal.z < -0.99 -> BACKWARD
            else -> null
        }
    }
}